import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

function CircularProgress(props) {
  return <CircularProgressbar styles={{path: {stroke: "#3D4256"}, trail: {stroke: "rgba(61,66,86,.3)"}}} {...props} />
}

export default CircularProgress
